
import * as yup from "yup";

export const FileUploadFormValidation = yup.object().shape({
    FileImage: yup.string()
        .trim()
        .required('Please Select File/Doc'),
    FileName: yup.string()
        .trim()
        .required('File Name Required'),
    Description: yup.string()
        .trim()
        .required('Description Required'),
});

export const FileEditFormValidation = yup.object().shape({
    FileName: yup.string()
        .trim()
        .required('File Name Required'),
});


